"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AbiType;

(function (AbiType) {
  AbiType["Function"] = "function";
  AbiType["Constructor"] = "constructor";
  AbiType["Event"] = "event";
  AbiType["Fallback"] = "fallback";
})(AbiType = exports.AbiType || (exports.AbiType = {}));

var SolidityTypes;

(function (SolidityTypes) {
  SolidityTypes["Address"] = "address";
  SolidityTypes["Uint256"] = "uint256";
  SolidityTypes["Uint8"] = "uint8";
  SolidityTypes["Uint"] = "uint";
})(SolidityTypes = exports.SolidityTypes || (exports.SolidityTypes = {}));